import React from "react";
import { CoinDetailsStyles } from "./styles/CoinDetails.styles";
import api from "src/store/features/api";
import { useTransactionSlice } from "src/store/features/transactions.slice";
import { formatCurrency, numberFormatter } from "src/utils/helpers/PriceAndUnitsHelpers";
import { HtmlTooltip } from "../trade/target-orders/tooltips/TargetOrderProjectionsToolTip";
import { Stack, Typography } from "@mui/material";
import InfoIconStyled from "src/icons/InfoIconStyled";
import { getTicker } from "src/utils/hooks/useGetTicker";
import { useUserSlice } from "src/store/features/user.slice";

export default function CoinProfileComponent() {
  const classes = CoinDetailsStyles();
  const {
    defaultCurrency: { code: baseCurrency },
  } = useUserSlice();
  const symbol = getTicker();
  const {
    recentTransaction: { date },
  } = useTransactionSlice();

  const {
    userHolding: { available, value } = {
      available: "0",
      value: "0",
    },
  } = api.useGetWalletPageHoldingsNewQuery(
    { baseCurrency },
    {
      selectFromResult: ({ data }) => ({
        userHolding: data?.find((userHolding) => userHolding.currencyConfig.code === symbol),
      }),
    },
  );

  const Item = (props: {
    label: string;
    units?: number | string;
    date?: string;
    available?: string | number;
  }) => {
    const { label, units, date, available } = props;
    function capitalizeFirstLetter(date: string) {
      let dateParts = date.split(" "); // ["26", "JUN", "2023"]
      if (dateParts[1]) {
        dateParts[1] = dateParts[1].charAt(0).toUpperCase() + dateParts[1].slice(1).toLowerCase();
      }
      return dateParts.join(" "); // "26 Jun 2023"
    }

    const noDate = date?.length === 0;
    const shortenedCurrency = available ? formatCurrency(+available, baseCurrency) : null;
    const captalisedDate = date ? capitalizeFirstLetter(date) : null;
    const dateOrValue = captalisedDate ?? numberFormatter(units || 0);
    const isLastTransactionItem = label.includes("Transaction");
    const onHoverMessage =
      "Deposit coins to view your balance here or learn more about transactions on our FAQ page";

    return (
      <div
        style={{
          marginBottom: "14px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          // gap: "8px",
        }}>
        <Stack direction={"row"}>
          <p className={classes.label}>{label}</p>
          {isLastTransactionItem && noDate && (
            <HtmlTooltip title={onHoverMessage} style={{ alignSelf: "center", padding: "4px" }}>
              <div>
                <InfoIconStyled />
              </div>
            </HtmlTooltip>
          )}
        </Stack>
        <div style={{ display: "flex" }}>
          {shortenedCurrency && (
            <Typography className={classes.value} display="inline" translate="no">
              {shortenedCurrency}
            </Typography>
          )}
          {noDate && <Typography className={classes.value}>-</Typography>}
          {dateOrValue && !shortenedCurrency && !noDate && (
            <Typography className={classes.value} translate="no">
              {dateOrValue}
            </Typography>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Balance information */}
      <div className={classes.layout}>
        <Item label={"Units"} units={available} />
        <Item label={"Available"} available={value} />
        <Item label={"Last Transaction"} date={date} />
      </div>
    </>
  );
}
